// extracted by mini-css-extract-plugin
export default {"success":"session-highlights_success__FqnGM","warning":"session-highlights_warning__oscGg","danger":"session-highlights_danger__dygqM"};